"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTeamPlayersSduiGroupDto = instanceOfTeamPlayersSduiGroupDto;
exports.TeamPlayersSduiGroupDtoFromJSON = TeamPlayersSduiGroupDtoFromJSON;
exports.TeamPlayersSduiGroupDtoFromJSONTyped = TeamPlayersSduiGroupDtoFromJSONTyped;
exports.TeamPlayersSduiGroupDtoToJSON = TeamPlayersSduiGroupDtoToJSON;
exports.TeamPlayersSduiGroupDtoToJSONTyped = TeamPlayersSduiGroupDtoToJSONTyped;
var DigestStepConfigDto_1 = require("./DigestStepConfigDto");
/**
 * Check if a given object implements the TeamPlayersSduiGroupDto interface.
 */
function instanceOfTeamPlayersSduiGroupDto(value) {
    if (!('teamCode' in value) || value['teamCode'] === undefined)
        return false;
    if (!('step' in value) || value['step'] === undefined)
        return false;
    return true;
}
function TeamPlayersSduiGroupDtoFromJSON(json) {
    return TeamPlayersSduiGroupDtoFromJSONTyped(json, false);
}
function TeamPlayersSduiGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'teamCode': json['teamCode'],
        'step': (0, DigestStepConfigDto_1.DigestStepConfigDtoFromJSON)(json['step']),
    };
}
function TeamPlayersSduiGroupDtoToJSON(json) {
    return TeamPlayersSduiGroupDtoToJSONTyped(json, false);
}
function TeamPlayersSduiGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'teamCode': value['teamCode'],
        'step': (0, DigestStepConfigDto_1.DigestStepConfigDtoToJSON)(value['step']),
    };
}
